import {
	getShopList,
	getOrderList,
	getSyncStatus,
	postOrderSync,
	postOrderRefresh,
	postOrderExport,
	postOrderDecode,
	getDeliveryAddress,
	postDeliveryAddress,
	postExplainAddress,
	getAddressCodeChildren,
	postMerchantNotes,
	postMarkProblem,
	postMarkException,
	getAddressImportProgress,
	postAddressImport,
} from "../../../api/wxshop/order.js";

let modules = {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		getShopListAction(conText, payload) {
			getShopList(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getOrderListAction(conText, payload) {
			getOrderList(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getSyncStatusAction(conText, payload) {
			getSyncStatus(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postOrderSyncAction(conText, payload) {
			postOrderSync(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postOrderRefreshAction(conText, payload) {
			postOrderRefresh(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postOrderExportAction(conText, payload) {
			postOrderExport(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postOrderDecodeAction(conText, payload) {
			postOrderDecode(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getDeliveryAddressAction(conText, payload) {
			getDeliveryAddress(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postDeliveryAddressAction(conText, payload) {
			postDeliveryAddress(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postExplainAddressAction(conText, payload) {
			postExplainAddress(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getAddressCodeChildrenAction(conText, payload) {
			getAddressCodeChildren(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postMerchantNotesAction(conText, payload) {
			postMerchantNotes(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postMarkProblemAction(conText, payload) {
			postMarkProblem(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.fail) payload.fail(err)
				else if (payload.error) payload.error(err)
			})
		},
		postMarkExceptionAction(conText, payload) {
			postMarkException(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.fail) payload.fail(err)
				else if (payload.error) payload.error(err)
			})
		},
		getAddressImportProgressAction(conText, payload) {
			getAddressImportProgress(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postAddressImportAction(conText, payload) {
			postAddressImport(payload.file).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
	}
}
export default modules;
